import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { MediaQuery, Button, Util, Link } from '@grandvisionhq/common';
import { Container, Heading, Text } from '@grandvisionhq/elements';
import { BannerTooltip } from '../BannerTooltip/BannerTooltip.js';

const SUPPORTED_STYLES = [
    'primary',
    'secondary',
    'primary outline',
    'secondary outline'
];
const ContentBanner = ({ image , mobileImage , title , text , links , textColor ='white' , tooltip ,  })=>{
    const isPhone = MediaQuery.useIsPhone();
    const imageUrl = isPhone ? mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url : image === null || image === void 0 ? void 0 : image.url;
    const imageLink = links.find(({ style  })=>style === 'image'
    );
    const [ref, inView] = useInView({
        rootMargin: '150px 0px',
        triggerOnce: true
    });
    const btnLinks = React.useMemo(()=>{
        return links.filter(({ style  })=>SUPPORTED_STYLES.includes(style !== null && style !== void 0 ? style : '')
        ).map(({ url , label , style , target  }, i)=>/*#__PURE__*/ React.createElement(Button, swcHelpers.extends({
                key: i,
                href: url,
                caption: label,
                className: "content-banner__button",
                hrefTarget: target === 'external' ? '_blank' : undefined
            }, Util.createButtonStyles(style)))
        );
    }, [
        links
    ]);
    if (!image && !title && !text) {
        console.warn('Cannot render ContentBanner: missing content');
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: `content-banner content-banner--color-${textColor}`,
        style: inView && imageUrl ? {
            backgroundImage: `url(${imageUrl})`
        } : undefined
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "content-banner__container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "content-banner__body"
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        className: "content-banner__title",
        component: "h2",
        variant: "large"
    }, title), text && /*#__PURE__*/ React.createElement(Text, {
        className: "content-banner__text"
    }, text), btnLinks, imageLink && /*#__PURE__*/ React.createElement(Link, {
        hidden: true,
        url: imageLink.url,
        target: imageLink.target,
        className: "content-banner__image-link"
    }, imageLink.label && /*#__PURE__*/ React.createElement("span", {
        className: "content-banner__image-link-text"
    }, imageLink.label))), tooltip && /*#__PURE__*/ React.createElement(BannerTooltip, {
        className: "content-banner__tooltip",
        tooltip: tooltip
    })));
};

export { ContentBanner as default };
//# sourceMappingURL=ContentBanner.js.map
